function Icon() {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M21.48 8.87H2.53v6.26h18.95z" />
    </svg>
  );
}

export default Icon;
